define((require) => {
    "use strict";

    const Class             = require("shared/util/Class"),
        _                   = require("underscore"),
        ImprovedView        = require("editor/zbone/ImprovedView"),
        DashboardSorting    = require("ui/dashboard/DashboardSorting"),
        TemplateSorting     = require("ui/dashboard/TemplateSorting"),
        Preconditions       = require("shared/util/Preconditions"),
        PublishableState    = require("util/PublishableState"),
        Backbone            = require("backbone"),
        Model               = Backbone.Model;

    const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

        ALPHABETICAL_GROUPS = {
            "0123456789": "0-9",
            "abcdeABCDE": "A-E",
            "fghijFGHIJ": "F-J",
            "klmnoKLMNO": "K-O",
            "pqrstPQRST": "P-T",
            "uvwxyzUVWXYZ": "U-Z"
        };

    const SortingTitles = {
        PERSON: "Me",
        UNKNOWN_PERSON: "Unknown",
        ALPHABETICAL: "Other"
    };

    const EMPTY = "Empty";

    const Header = ImprovedView.extend({

        template: _.template("<h4 class='experience-group-title'><%- name %></h4>"),

        tagName: "header",

        className: "group-header"

    });

    const Factory = Class.extend({

        /**
         * @type {Function}
         */
        view: Header,

        /**
         * @type {String}
         */
        _name: null,

        constructor: function(options) {
            this.options = options;
        },

        create: function(index, model) {
            this._name = this.name(model);

            const View = this.view;

            return new View({model: new Model({name: this._name})});
        },

        name: function() {
            Preconditions.abstractMethodError();
        },

        contains: function(model) {
            return this._name === this.name(model);
        }

    });

    const factories = new Map();

    factories.set(DashboardSorting.MONTH, Factory.extend({

        name: function(model) {
            const date = new Date(model.get("editedAt"));

            return MONTH_NAMES[date.getMonth()] + " " + date.getFullYear();
        }

    }));

    factories.set(DashboardSorting.ALPHABETICAL, Factory.extend({

        name: function(model) {
            const character = model.get("name").charAt(0);
            const name = _.find(ALPHABETICAL_GROUPS, (val, key) => {
                return _.contains(key, character);
            });

            return _.isUndefined(name) ? SortingTitles.ALPHABETICAL : name;
        }

    }));

    factories.set(DashboardSorting.PERSON, Factory.extend({

        name: function(model) {
            const users = this.options.users,
                myUserId = this.options.principal.get("userId"),
                createdById = model.get("createdBy");

            if (createdById === myUserId) {
                return SortingTitles.PERSON;
            }

            return users.get(createdById) || SortingTitles.UNKNOWN_PERSON;
        }

    }));

    factories.set(DashboardSorting.STATE, Factory.extend({

        name: function(model) {
            return PublishableState.getEnum(model.get("state")).displayName;
        }

    }));

    factories.set(TemplateSorting.ALPHABETICAL, Factory.extend({

        name: function() {
            return "";
        }

    }));

    factories.set(TemplateSorting.CREATED, Factory.extend({

        name: function() {
            return "New Experience";
        }

    }));

    factories.set(EMPTY, Factory.extend({

        name: function() {
            return " ";
        }

    }));

    return Class.extend({

        _factory: null,

        _sorting: null,

        constructor: function(options) {
            this.options = options;
        },

        create: function(sorting, index, model) {
            Preconditions.checkState(factories.has(sorting), "Unknown sorting specified: " + sorting);

            if (this._sorting !== sorting) {
                this._sorting = sorting;


                const Factory = factories.get(sorting);

                this._factory = new Factory(this.options);
            }

            if (!this._factory.contains(model)) {
                return this._factory.create(index, model);
            }
        },

        reset: function() {
            this._factory = null;
            this._sorting = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardHeaderFactory.js